/**
 * LockdownStatusPage.js — Public admin-oriented sealed-project status page.
 * Route: /lockdown-status
 */
import React, { useState, useEffect } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const NAVY = "#020A1F"; const CYAN = "#00CFCF"; const CHROME = "#A0A0A0"; const INK = "#F5F5F7";
const shell = { minHeight: "100dvh", background: NAVY, color: INK, padding: "clamp(16px,3vw,32px)", fontFamily: "'Inter', system-ui, sans-serif", boxSizing: "border-box" };
const card = { background: "rgba(255,255,255,0.03)", border: `1px solid ${CHROME}33`, borderRadius: 12, padding: "clamp(14px,2.5vw,22px)", marginBottom: 16 };

export default function LockdownStatusPage() {
  const [feed, setFeed] = useState({ sealed_count: 0, projects: [] });
  const [busy, setBusy] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch(`${BACKEND_URL}/api/lockdown/sealed-projects`, { credentials: "include" });
        if (r.ok && !cancelled) setFeed(await r.json());
      } finally { if (!cancelled) setBusy(false); }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <div style={shell} data-testid="lockdown-status-shell">
      <div style={{ ...card, borderColor: `${CYAN}44` }}>
        <div style={{ fontSize: 11, letterSpacing: "0.2em", color: CYAN, marginBottom: 6 }}>
          MOOVIN FORWARD LLC · SEALED PROJECT LEDGER
        </div>
        <h1 style={{ margin: 0, fontSize: "clamp(20px, 3vw, 26px)" }}>LOCKED_SECURE badge feed</h1>
        <div style={{ color: CHROME, marginTop: 6, fontSize: 13 }}>
          Live count of every project the digital platform has sealed after completion signoff + 72-hour payout clearance.
        </div>
      </div>
      <div style={{ ...card, background: "rgba(0,207,207,0.05)", borderColor: `${CYAN}44` }} data-testid="locked-secure-badge-panel">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ fontSize: 11, letterSpacing: "0.2em", color: CYAN }}>🔒 LOCKED_SECURE PROJECTS</div>
          <div style={{ fontSize: 24, fontWeight: 800, color: CYAN }} data-testid="locked-secure-count">
            {busy ? "…" : feed.sealed_count}
          </div>
        </div>
        {feed.projects.length > 0 && (
          <ul style={{ margin: "12px 0 0", padding: 0, listStyle: "none" }}>
            {feed.projects.slice(0, 8).map(p => (
              <li key={p.lockdown_id} style={{ padding: "6px 0", borderTop: `1px solid ${CHROME}22`, fontSize: 12, color: INK }}>
                <strong>{p.project_id}</strong> · sealed by {p.sealed_by_email} · <span style={{ color: CHROME }}>{p.sealed_at}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
